import { request } from "../_helpers/Auth";

const namespace = "/api";

export const getUserContracts = (user_id) => {
    return request({
        url: namespace + "/contracts/" + user_id,
        method: "get",
    });
};

export const createContract = (payload, user_id) => {
    return request({
        url: namespace + "/contract/" + user_id,
        data: payload,
        method: "post",
    });
};

export const editContract = (payload, contract_id) => {
    return request({
        url: namespace + "/contract/" + contract_id,
        data: payload,
        method: "put",
    });
};

export const deleteContract = (contract_id) => {
    return request({
        url: namespace + "/contract/" + contract_id,
        method: "delete",
    });
};
